export const notificationConstants = {
    NOTIFICATION_FETCHING: 'NOTIFICATION_FETCHING',
    NOTIFICATION_FETCHED: 'NOTIFICATION_FETCHED',
    NOTIFICATION_SUBMITTING: 'NOTIFICATION_SUBMITTING',
    NOTIFICATION_SUBMITTED: 'NOTIFICATION_SUBMITTED',
    GET_NOTIFICATION_LOGS: 'GET_NOTIFICATION_LOGS',
    GET_ALL_NOTIFICATIONS: 'GET_ALL_NOTIFICATIONS',
    CLEAR_ALL_NOTIFICATIONS: 'CLEAR_ALL_NOTIFICATIONS',
}